import * as actionTypes from './actionTypes';
import { vignetteService } from './services';
import { actionsModalError } from '@app/src/common/modalError';

const fetchVignetteRequest = () => ({
  type: actionTypes.FETCH_VIGNETTE_REQUEST
});

const fetchVignetteSuccess = (data) => ({
  type: actionTypes.FETCH_VIGNETTE_SUCCESS,
  data
});

const fetchVignetteFailure = () => ({
  type: actionTypes.FETCH_VIGNETTE_FAILURE
});

export const fetchVignette = (categoryId:number, publicationId: number): Function => {
  return async dispatch => {
    dispatch(fetchVignetteRequest());
    try {
      const data = await vignetteService.get(categoryId, publicationId);
      dispatch(fetchVignetteSuccess(data));
    } catch(e) {
      dispatch(fetchVignetteFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
